
		<h3 class="title" i18n="@@machineModels">Machine Models</h3>

		<mat-accordion>
			<mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
				<mat-expansion-panel-header>
					<div *ngIf="tableService.filter" class="filter-panel-header fieldset-wrap">
						<div class="field-row">
							<div class="field-row-item" *ngIf="tableService.filter.name">
								<span class="label" i18n="@@name">Name</span>
								<span>{{tableService.filter.name}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.name">
								<span class="label" i18n="@@name">Name</span>
								<span>{{tableService.filter.name}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.machineType">
								<span class="label" i18n="@@machineType">Machine type</span>
								<span>{{tableService.filter.machineType.name}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.machineBrand">
								<span class="label" i18n="@@machineBrand">Machine brand</span>
								<span>{{tableService.filter.machineBrand.name}}</span>
							</div>
						</div>
					</div>
					<button class="btn-icon" i18n-title="@@option-search" title="Search" type="button">
						<i class="material-icons">search</i>
					</button>
				</mat-expansion-panel-header>

				<form>
					<fieldset class="fieldset">
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="name" i18n="@@code">Code</label>
								<input type="text" name="name" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.name">
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="comercialName" i18n="@@name">Name</label>
								<input type="text" name="comercialName" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.comercialName">
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="machineType" i18n="@@machineType">Machine Type</label>
								<mat-select placeholder="None" i18n-placeholder="None" [(value)]="filter.machineType" [compareWith]="compareFn" disableRipple>
									<mat-option i18n="@@select-none">None</mat-option>
									<mat-option *ngFor="let opt of machineTypes" [value]="opt">{{opt.name}}</mat-option>
								</mat-select>
							</div>
							<div class="field-row-item">
								<label class="label" for="machineBrand" i18n="@@machineBrand">Machine Brand</label>
								<mat-select placeholder="None" i18n-placeholder="None" [(value)]="filter.machineBrand" [compareWith]="compareFn" disableRipple>
									<mat-option i18n="@@select-none">None</mat-option>
									<mat-option *ngFor="let opt of machineBrands" [value]="opt">{{opt.name}}</mat-option>
								</mat-select>
							</div>
						</div>
					</fieldset>
					<div class="options">
						<button class="btn-text gray" type="button" (click)="reset()">
							<span i18n="@@option-reset">Reset</span>
						</button>
						<button class="btn-text blue" type="button" (click)="search()">
							<span i18n="@@option-search">Search</span>
						</button>
					</div>
				</form>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="tool-bar-wrap both-side">
			<div class="right row">
				<button class="btn-icon" i18n-title="@@option-create" type="button" (click)="create()" *hasPermission="['MachineModels.create']">
					<i class="material-icons">add</i>
				</button>
				<ng-template [hasPermission]="['MachineModels.delete']">
					<button class="btn-icon" i18n-title="@@option-delete" title="Delete" type="button" (click)="confirmDelete = false" *ngIf="tableService.selection.hasValue()">
						<i class="material-icons">delete</i>
					</button>
				</ng-template>
			</div>
		</div>

		<div class="mat-elevation-z8e" *ngIf="dataSource">
			<table mat-table [dataSource]="dataSource" matSort (matSortChange)="tableService.sortData($event); list();">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="tableService.masterToggle(dataSource.data)"
							[checked]="tableService.selection.hasValue() && tableService.isAllSelected(dataSource.data.length)"
							[indeterminate]="tableService.selection.hasValue() && !tableService.isAllSelected(dataSource.data.length)"
							*hasPermission="['MachineModels.delete']">
						</mat-checkbox>
					</th>
					<td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
							(change)="tableService.selection.toggle(row)"
							[checked]="tableService.selection.isSelected(row)"
							*hasPermission="['MachineModels.delete']">
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@code">Code</th>
					<td mat-cell *matCellDef="let element">{{element.name}}</td>
				</ng-container>

				<ng-container matColumnDef="comercialName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name">Name</th>
					<td mat-cell *matCellDef="let element">{{element.comercialName}}</td>
				</ng-container>

				<ng-container matColumnDef="machineType.name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@machineType">Machine Type</th>
					<td mat-cell *matCellDef="let element">{{element.machineType?.name}}</td>
				</ng-container>

				<ng-container matColumnDef="machineBrand.name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@machineBrand">Machine Brand</th>
					<td mat-cell *matCellDef="let element">{{element.machineBrand?.name}}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(contextmenu)="tableService.selection.clear(); tableService.selection.select(row)" [contextMenu]="basicMenu" [contextMenuSubject]="row"
					(click)="read(row)">
				</tr>
			</table>

			<mat-paginator showFirstLastButtons
				[length]="tableService.pager.totalEntities"
				[pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
				[pageSizeOptions]="[20, 50, 100]"
				(page)="list($event)">
			</mat-paginator>
		</div>

		<context-menu #basicMenu>
			<ng-template [hasPermission]="['MachineModels.update']">
				<ng-template contextMenuItem (execute)="update($event.item)">
					<div class="item">
						<i class="material-icons">edit</i>
						<span i18n="@@option-update">Update</span>
					</div>
				</ng-template>
			</ng-template>
			<ng-template [hasPermission]="['MediaController.createMachineModels']">
				<ng-template contextMenuItem (execute)="updateImages($event.item)">
					<div class="item">
						<i class="material-icons">collections</i>
						<span i18n="@@option-update-images">Update images</span>
					</div>
				</ng-template>
				<ng-template contextMenuItem (execute)="updatePdfs($event.item)">
					<div class="item">
						<i class="material-icons">picture_as_pdf</i>
						<span i18n="@@option-update-pdfs">Update PDF files</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['MachineModels.delete']">
				<ng-template contextMenuItem divider="true"></ng-template>
				<ng-template contextMenuItem (execute)="confirmDelete = false">
					<div class="item">
						<i class="material-icons">delete</i>
						<span i18n="@@option-delete">Delete</span>
					</div>
				</ng-template>
			</ng-template>
		</context-menu>

		<modal-ns [(closed)]="confirmDelete">
			<ng-template modalContentDirective>
				<div class="dialog-content">
					<div class="dialog-title" i18n="@@confirm">Confirmation</div>
					<div class="dialog-message" i18n="@@confirm-deletes">Are you sure you want to delete the selected items?</div>
					<div class="options">
						<button class="btn-text red" type="button" (click)="confirmDelete = true">
							<span i18n="@@option-no">No</span>
						</button>
						<button class="btn-text green" type="button" (click)="deletes(); confirmDelete = true">
							<span i18n="@@option-yes">Yes</span>
						</button>
					</div>
				</div>
			</ng-template>
		</modal-ns>
	